import { useState, useEffect, useCallback } from "react";
import { suppliesService } from "../services/suppliesService";

export function useSupplies() {
  const [supplies, setSupplies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Estados para Comboboxes Automáticas
  const [availableSectors, setAvailableSectors] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [availableUnits, setAvailableUnits] = useState([]);

  // Função central para buscar tudo e já extrair as categorias únicas
  const fetchSupplies = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await suppliesService.getSupplies();
      // Oculta os registros internos de configuração do estoque físico e faz o parse de stone_properties
      const physicalSupplies = data
        .filter((s) => s.name !== "__zirconia_config__" && s.name !== "__bom_templates__")
        .map((s) => {
          let props = s.stone_properties;
          if (typeof props === "string" && props.trim() !== "") {
            try {
              props = JSON.parse(props);
            } catch (e) {
              console.warn("Falha ao converter stone_properties em objeto:", s.name, e);
            }
          }
          return {
            ...s,
            stone_properties: props || {}
          };
        });
      setSupplies(physicalSupplies);

      // Extrai valores únicos (Distinct) dos textos dinâmicos (apenas dos insumos físicos)
      const sectors = Array.from(new Set(physicalSupplies.map((s) => s.sector).filter(Boolean))).sort();
      const categories = Array.from(new Set(physicalSupplies.map((s) => s.category).filter(Boolean))).sort();
      const units = Array.from(new Set(physicalSupplies.map((s) => s.unit).filter(Boolean))).sort();

      setAvailableSectors(sectors);
      setAvailableCategories(categories);
      setAvailableUnits(units);
    } catch (err) {
      console.error("Erro ao buscar insumos:", err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Carrega ao montar
  useEffect(() => {
    fetchSupplies();
  }, [fetchSupplies]);

  // Ações
  const addSupply = async (supplyData) => {
    const newSupply = await suppliesService.createSupply(supplyData);
    await fetchSupplies(); // Re-fetch para atualizar lista e categorias
    return newSupply;
  };

  const editSupply = async (id, supplyData) => {
    const updated = await suppliesService.updateSupply(id, supplyData);
    await fetchSupplies();
    return updated;
  };

  const removeSupply = async (id) => {
    await suppliesService.deleteSupply(id);
    await fetchSupplies();
  };

  return {
    supplies,
    isLoading,
    error,
    availableSectors,
    availableCategories,
    availableUnits,
    fetchSupplies,
    addSupply,
    editSupply,
    removeSupply,
  };
}
